import type { MyBridgeAgentConversationRow, MyBridgeTakeoverReason } from '@common/reducers/backend-api/backend-api';

/** What the "Paused" badge shows for one conversation (#1029). null = not paused: no badge. */
export interface PausedBadgeView {
  reasonKey: string;
  since: string | null;
  /** The auto-resume instant, or null = "paused until you resume". */
  until: Date | null;
}

const REASON_KEYS: Record<MyBridgeTakeoverReason, string> = {
  auto_human_typed: 'myBridge.conversations.pausedReasonAuto',
  manual: 'myBridge.conversations.pausedReasonManual',
};

const parseDate = (iso: string | null): Date | null => {
  if (!iso) return null;
  const d = new Date(iso);
  return Number.isFinite(d.getTime()) ? d : null;
};

/** The badge for a conversation's `takeover`; an unknown/missing reason reads as manual. */
export function pausedBadgeFor(takeover: MyBridgeAgentConversationRow['takeover']): PausedBadgeView | null {
  if (takeover.paused !== true) return null;
  return {
    reasonKey: takeover.reason ? REASON_KEYS[takeover.reason] ?? REASON_KEYS.manual : REASON_KEYS.manual,
    since: takeover.since,
    until: parseDate(takeover.until ?? null),
  };
}

/** "HH:MM" in the viewer's locale; with the date when the resume is not today. */
export function formatResumeTime(until: Date, locale: string, now: Date = new Date()): string {
  const time = new Intl.DateTimeFormat(locale, { hour: '2-digit', minute: '2-digit' }).format(until);
  if (until.toDateString() === now.toDateString()) return time;
  return `${new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'short' }).format(until)} ${time}`;
}
